import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';


const PageModalites = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('modalites')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    return (
        <div>
            <h1>Fonctionnement général</h1>
            <p>Cette UV se déroule essentiellement à distance. Il y a un cours lors de la semaine de rentrée, et 5 séances de TD en salle informatique, en tout et pour tout. Chaque séance de TD dure 4 heures, et comporte un Contrôle Continu en fin de séance (d’une heure environ), sur machine. La certification nationale PIX est également proposée en fin de semestre (comme supplément au diplôme), et constitue un des critères d’attribution de l’UV (mais pas le seul).
            </p>
            <p>L’UV est attribuée en fonction des résultats :</p>
            <ul>
                <li>Aux tests de positionnement PIX ;</li>
                <li>À la certification PIX ;</li>
                <li>Aux 5 Contrôles Continus de chacun des 5 TD ;</li>
                <li>Aux travaux réalisés pour rattraper les Contrôles Continus, en cas d’échec d’un contrôle.</li>
            </ul>
            <br />
            <h1>Charges de travail</h1>
            <p>Les étudiants doivent réaliser divers travaux : Tests de positionnement sur les 16 compétences PIX et exercices de rattrapage (pour les Contrôles Continus ratés) : applications pratiques (TP), devoirs (Projets), exercices difficiles, contrôles continus réalisés lors des séances de TD. Tout ceci nécessite beaucoup de préparation et de travail à distance.</p>
            <p>Travail estimé pour un étudiant :</p>
            <ul>
                <li>20 h TD (5 séances de 4h chacune) ;</li>
                <li>20h apprentissage du Cours ;</li>
                <li>20 h devoirs et exercices de préparation ou de rattrapage ;</li>
                <li>30 h tests de positionnement PIX et révisions.</li>
            </ul>
            <p>Il n'y a pas de cours en amphi. L'objectif est d'acquérir plus de compétences que de connaissances. Les cours de TD servent à suivre l'avancement des étudiants, expliquer le cours, faire des démonstrations, poser des questions et effectuer un contrôle continu.</p>
            <br />
            <h1>Évaluation</h1>
            <p>Les examens se font sur ordinateur (épreuve théorique et pratique), en salle machine UTC :</p>
            <table>
                <tr className="table-head">
                    <th>Épreuve de certification</th>
                    <th>Épreuve pratique</th>
                </tr>
                <tr>
                    <td>Épreuve nationale de certification PIX</td>
                    <td>Effectuée en contrôle continu lors de chaque séance de TD, sur machine.</td>
                </tr>
            </table>
            <p>L’épreuve pratique de contrôle continu conditionne la réussite à l’UV. Il faut valider toutes les compétences à l’épreuve pratique, dans <b>chacune des compétences.</b></p>
            <br />
            <h1>Plus d'informations</h1>
            <p>Cliquez sur le bouton ci-dessous pour télécharger le PDF expliquant l'UV en détails.</p>
            <Button align="right" to="pdf/nf05.pdf" type="download">Télécharger le document</Button>
            <br />
            <p>Pour voir les vidéos de l’UV, cliquez sur le bouton suivant :</p>
            <Button align="center" icon="arrow-right" to="?page=videos">Vidéos de l'UV</Button>
        </div>
    );
}

export default PageModalites;